import { useTranslations } from "@zapier/i18n";
import {
  DefaultViewButton,
  SearchInput,
  useRouterParams,
} from "@zapier/shared";
import { useCallback, useEffect, useState } from "react";
import { BetaPageHeader, Button } from "@zapier/design-system";
import { Icon } from "@zapier/zinnia-icons";

import styles from "./TemplatesHeader.module.css";
import { TemplatesSharingFilter, TemplatesFilters } from "./TemplatesFilters";

interface TemplatesHeaderProps {
  showSearch?: boolean;
}

export function TemplatesHeader({ showSearch = true }: TemplatesHeaderProps) {
  const t = useTranslations("templates-header");

  const { app, owner, status, setParams } = useRouterParams();
  const [showFilters, setShowFilters] = useState(false);

  // Show filters panel on mount if URL already has filter params (same as ZapsHeader)
  useEffect(() => {
    if (owner || app || status) {
      setShowFilters(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- only check on mount
  }, []);

  const search = useCallback(
    (searchValue: string) => {
      setParams({ search: searchValue }, ["page"]);
    },
    [setParams],
  );

  return (
    <BetaPageHeader
      title={t("titles.templates")}
      additionalContent={
        showSearch ? (
          <div className={styles.root}>
            <div className={styles.topRow}>
              <SearchInput
                placeholder={t("search.placeholder")}
                onSearch={search}
              />

              <div className={styles.sharing}>
                <TemplatesSharingFilter />
              </div>

              <Button
                size="medium"
                variant={showFilters ? "secondary" : "tertiary"}
                onClick={() => setShowFilters(!showFilters)}
                iconPosition="start"
              >
                <Icon name="statusFilter" aria-hidden={true} />
                {t("filters.button-label")}
              </Button>

              <DefaultViewButton />
            </div>

            {showFilters && (
              <div className={styles.filters}>
                <TemplatesFilters />
              </div>
            )}
          </div>
        ) : undefined
      }
    />
  );
}
